import { css } from '@emotion/react'
import { SContentContainer, SDot } from './DigitalLegacyAbout.styled'
import { Stack } from 'components/Stack'

import { Text, Title, Title_h3_default } from 'components/Typography'
import { forwardRef, Fragment } from 'react'
import { BREAKPOINTS, pxToRem } from 'utils/styled'

export const DigitalLegacyAbout = forwardRef<
  HTMLDivElement,
  {
    title?: string | null
    description?: string | null
    className?: string
    items?:
      | {
          content?: string | null
          icon?: string | null
        }[]
      | null
  }
>((props, ref) => {
  return (
    <div
      ref={ref}
      css={css`
        padding-top: ${pxToRem(145)}rem;
        padding-bottom: ${pxToRem(70)}rem;

        @media ${BREAKPOINTS.MD.max} {
          padding-top: ${pxToRem(30)}rem;
          padding-bottom: ${pxToRem(20)}rem;
        }
      `}
      className={props.className}
    >
      <SContentContainer orientation="horizontal" space={`${pxToRem(90)}rem`}>
        <Stack space={`1.2rem`}>
          <Title variant={Title_h3_default} as="h3">
            {props.title}
          </Title>

          <Text css={{ whiteSpace: 'pre-line' }}>{props.description}</Text>

          <Fragment>
            {props.items?.map(({ content }, index) => (
              <Stack
                key={index}
                orientation="horizontal"
                space=".5rem"
                css={{ alignItems: 'center' }}
              >
                <SDot />
                <Text>{content}</Text>
              </Stack>
            ))}
          </Fragment>
        </Stack>
        <img
          src="/digital-legacy/authorsLarge.jpg"
          srcSet="/digital-legacy/authorsLarge.jpg 1x, /digital-legacy/authorsLarge@2x.jpg 2x"
          alt="Authors of Digital Legacy book, Daniel Sieberg &amp; Rikard Steiber"
          css={css`
            cursor: pointer;
            width: 100%;
            @media ${BREAKPOINTS.LG.max} {
              display: none;
            }
          `}
        />
      </SContentContainer>
    </div>
  )
})
DigitalLegacyAbout.displayName = 'DigitalLegacyAbout'
